import { render } from "./TableTitle.vue?vue&type=template&id=3f0e6f1a"
import script from "./TableTitle.vue?vue&type=script&lang=js"
export * from "./TableTitle.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__